import { createFileRoute } from "@tanstack/react-router";

import ExtensionCaptchaChallengePage from "../-components/ExtensionCaptchaChallengePage";

export const Route = createFileRoute(
  "/_app/_dashboard/extension-captcha-challenge"
)({
  component: ExtensionCaptchaChallengePage,
});
